import React, { useState, useEffect, useContext, useRef } from 'react';
import {ResourceList as ResourceListShopify, Avatar, TextStyle, Stack, Link, TopBar, Icon} from '@shopify/polaris';
import {EditMinor} from '@shopify/polaris-icons';
import {SearchContext} from '@thinkwell/react.common';
import {ResourceList} from '@thinkwell/react.polaris';
import EditProduct from './EditProduct';
import MainFrame from '../MainFrame';
import { ProductsContext } from '../contexts/Products'
import { CoursesProvider } from '../contexts/Courses'
import compact from 'lodash/compact';
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy'

const formatDate = (dateStr) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateStr))
};

export default function Products(props) {
  const [products, fetchProducts, fetchProductsState] = useContext(ProductsContext);
  const [search, setSearch] = useContext(SearchContext);

  const navigateToRef = useRef()
  const [addProductActive, setAddProductActive] = useState(false);
  const [editProductItem, setEditProductItem] = useState()
  const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);
  const toggleIsProductMenuOpen = () => setIsProductMenuOpen((isProductMenuOpen) => !isProductMenuOpen);

  const productsSorted = sortBy(products, ['name']);

  const onSearch = (params) => {
    fetchProducts(`/products.json`, params)
  }

  const delayedSearch = useRef(debounce(onSearch, 1000));

  const onSearchChange = (value) => {
    setSearch(value)
    delayedSearch.current({query: value})
  }

  const productMenuMarkup = (
     <TopBar.UserMenu
       actions={[
         {
           items: [
             {content: 'Add Product', onAction: () => { setEditProductItem(null); setAddProductActive(true) }},
             {content: 'Logout', url: '/logout'}
           ]
         }
       ]}
       name="Products"
       initials="P"
       open={isProductMenuOpen}
       onToggle={toggleIsProductMenuOpen}
     />
   );

  const renderProduct = (item) => {
    const {name} = item;
    return (
      <ResourceListShopify.Item
        id={item.id}
        accessibilityLabel={`View details for ${name}`}
        onClick={() => navigateToRef.current(`products/${item.id}`, {withContext: true})}
        shortcutActions={[{content: <Icon source={EditMinor} />, onAction: () => { setEditProductItem(item); setAddProductActive(true) }}]}
      >
        <Stack>
          <Stack.Item fill>
            <h3>
              <TextStyle variation="strong">{name}</TextStyle>
            </h3>
          </Stack.Item>
          <Stack.Item>
            <TextStyle variation="subdued">{formatDate(item.updated_at)}</TextStyle>
          </Stack.Item>
        </Stack>
      </ResourceListShopify.Item>
    );
  };

  const onAddProduct = (product) => {
    if (!editProductItem) {
      navigateToRef.current(`products/${product.id}`)
    }
  }

  return (
    <div>
    <MainFrame onSearchChange={onSearchChange} searchPlaceHolder="Search products"
    userMenu={productMenuMarkup} navigateToRef={navigateToRef}>
      { addProductActive ?
        <EditProduct
          item={editProductItem}
          active={addProductActive}
          onActive={(active) => { if (active != addProductActive) { setAddProductActive(active) }}}
          onSave={onAddProduct}
        /> :
        <ResourceList withoutSort items={productsSorted} fetchItems={fetchProducts} fetchItemsState={fetchProductsState}
        url="/products.json" renderItem={renderProduct}
        resourceName={ {singular: 'product', plural: 'products'} }></ResourceList>
      }
    </MainFrame>
  </div>);
}
